import ApiService from "./../api/ApiService";
import Urls from "./../api/Urls";
import Config from "../constants/Config";
import PointChangeHistory from "../models/PointChangeHistory";
import {
  parsePointChangeHistoryListReponseParams,
} from "../utils/commonUtils";
import { isEmpty } from "lodash";

export function getListPointChangeHistory(params = {}) {
  return new ApiService({
    baseURL: Config.API_ORDER,
    endpoint: Urls.GET_LIST_REFUND_HISTORIES,
    params: params,
    parser: pointChangeHistoryDataParser,
  }).get();
}

export function confirmPointChangeHistory(params = {}) {
  return new ApiService({
    baseURL: Config.API_ORDER,
    endpoint: Urls.CONFIRM_REFUND_HISTORIES,
    params: params,
    parser: pointChangeHistoryDataParser,
  }).post();
}

export function cancelPointChangeHistory(params = {}) {
  return new ApiService({
    baseURL: Config.API_ORDER,
    endpoint: Urls.CANCEL_REFUND_HISTORIES,
    params: params,
    parser: pointChangeHistoryDataParser,
  }).post();
}


const pointChangeHistoryDataParser = (data) => {
  if (isEmpty(data.result)) {
    return { pointChangeHistory: [], ...parsePointChangeHistoryListReponseParams(data) };
  }
  return {
    pointChangeHistory: (data.result || []).map((item) => new PointChangeHistory(item)),
    ...parsePointChangeHistoryListReponseParams(data),
  };
};
